import * as React from 'react'
import Svg, { Circle, G, Path, SvgProps } from 'react-native-svg'

export const ChatSelected = (props: SvgProps) => {
  const { color } = props
  const dotsColor = color === '#FFFFFF' ? '#2d2d2d' : '#fff'

  return (
    <Svg fill='none' height='26' viewBox='0 0 30 26' width='30' {...props}>
      <Path
        clipRule='evenodd'
        d='m4.47136 0c-1.5328 0-2.81908 1.15548-2.98283 2.6795l-1.4710268 13.6906c-.1905572 1.7735 1.1991368 3.3205 2.9828368 3.3205h11.24806l2.7073 3.9916c1.5736 2.3201 5.1867 1.406 5.4677-1.3833l.2627-2.6083h2.8418c1.5328 0 2.8191-1.1555 2.9828-2.6795l1.471-13.6906c.1906-1.77349-1.1991-3.3205-2.9828-3.3205z'
        fill={color}
        fillRule='evenodd'
      />
      <G fill={dotsColor}>
        <Circle cx='8' cy='10' r='2' />
        <Circle cx='15' cy='10' r='2' />
        <Circle cx='22' cy='10' r='2' />
      </G>
    </Svg>
  )
}
